import React from "react";
import { useSelector } from "react-redux";

import { questionProps } from "lib/propTypes";
import TextFollowUp from "./TextFollowUp";
import MultiSelectFollowUp from "./MultiSelectFollowUp";

const FollowUp = ({ follow_up_options: followUpOptions, ...props }) => {
    const selfIdentifyOff = useSelector(
        (state) => !!state.company?.settings?.retain?.self_identify_off,
    );
    const FollowUpComponent =
        followUpOptions?.options?.length > 0 ? MultiSelectFollowUp : TextFollowUp;

    return (
        <FollowUpComponent
            follow_up_options={followUpOptions}
            selfIdentifyOff={selfIdentifyOff}
            {...props}
        />
    );
};

FollowUp.propTypes = {
    follow_up_options: questionProps.follow_up_options,
};

FollowUp.defaultProps = {
    follow_up_options: null,
};

export default React.memo(FollowUp);
